import {
  defineBorderStyle,
  defineFontFamily,
  getThemeEditorSettingsVariables,
  setVariablesStyle,
} from 'utils/helper-functions/create-styles';
import { setBrandColors } from 'utils/helper-functions/set-brand-colors';
import { applyFontFamilyFromTheme } from 'utils/fonts-functions/fonts-functions';
import {
  embeddedBrandColorsDark,
  embeddedBrandColorsLight,
  embeddedButtonStyle,
  embeddedFont,
} from './boot-header-settings';

export const createBootThemeVariables = () => {
  let injected = false;

  const inject = (appearanceMode: string): void => {
    if (injected) return;
    injected = true;

    const isDarkTheme = appearanceMode === 'dark-mode';

    const themeEditorVariables = getThemeEditorSettingsVariables({
      border_style: defineBorderStyle(embeddedButtonStyle ?? undefined),
      font_family: defineFontFamily(embeddedFont ?? ''),
      font_size: '16px',
      primary_btn_color_text: '#F2F2F2',
      shadow_color: 'rgb(112, 144, 176)',
    });

    setVariablesStyle(themeEditorVariables, ':root', 'theme-editor-settings');

    const brandColor = isDarkTheme ? embeddedBrandColorsDark : embeddedBrandColorsLight;

    setBrandColors(isDarkTheme ? 'dark' : 'light', brandColor ? { primary: brandColor } : {});

    if (embeddedFont && embeddedFont.toLocaleLowerCase() !== 'default') {
      applyFontFamilyFromTheme(embeddedFont);
    }
  };

  return { inject };
};

export const bootThemeVariables = createBootThemeVariables();
